module.exports = __webpack_public_path__ + "img/zf-chassis-logo.cd225c6a.jpg";